<template>
  <tr v-if="requirement.editing" class="requirement row location editing" key="editing" ref="editingRow">
    <can I="edit" a="Opportunity">
      <th v-if="first" class="text-xs-right">Candidate</th>

      <td v-else class="text-xs-right">
        {{ requirement.mandatory ? 'and' : 'or' }}
      </td>

      <td colspan="2">
        <v-toolbar flat class="transparent">
          <v-select
            v-model="requirement.mandatory"
            :items="[{ text: 'must', value: true }, { text: 'could', value: false }]"
            ref="mandatoryInput"
          />

          <v-select
            v-model="requirement.negative"
            :items="[{ text: 'not be within', value: true }, { text: 'be within', value: false }]"
            class="pl-2"
            ref="negativeInput"
          />

          <v-text-field
            label="Radius"
            v-model="input.radius"
            required
            mask="#####"
            suffix="km"
            ref="radiusInput"
          />

          <label class="body px-2">from</label>

          <v-text-field label="Address" v-model="input.address" required ref="addressInput" />

          <v-spacer />

          <!-- Cancel Button -->
          <v-tooltip left color="grey darken-3">
            <v-btn small flat fab
              slot="activator"
              key="cancel"
              @click="cancel"
              color="grey"
              ref="cancelBtn"
            >
              <v-icon>mdi-cancel</v-icon>
            </v-btn>
            <span>Cancel</span>
          </v-tooltip>

          <!-- Delete Button -->
          <v-tooltip left v-if="requirement.id" color="grey darken-3">
            <v-btn small flat error fab
              slot="activator"
              key="delete"
              @click="destroy"
              color="error"
              ref="destroyBtn"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
            <span>Delete</span>
          </v-tooltip>

          <!-- Submit Button -->
          <v-tooltip left color="grey darken-3">
            <v-btn small fab
              slot="activator"
              key="save"
              @click="submit"
              color="primary"
              ref="submitBtn"
            >
              <v-icon>mdi-content-save</v-icon>
            </v-btn>
            <span v-if="requirement.id">Update</span>
            <span v-else>Create</span>
          </v-tooltip>
        </v-toolbar>
      </td>
    </can>
  </tr>
  <tr v-else class="requirement row location viewing" key="viewing" ref="viewingRow">
    <th v-if="first" class="text-xs-right">Candidate</th>
    <td v-else class="text-xs-right">
      {{ requirement.mandatory ? 'and' : 'or' }}
    </td>
    <td>
      {{ requirement.mandatory ? 'must' : 'could' }}
      {{ requirement.negative ? 'not be within' : 'be within' }}
      <em>{{ requirement.value }}</em>
    </td>
    <td class="text-xs-right">
      <can I="edit" a="Opportunity">
        <v-btn small flat @click.prevent="requirement.editing = true" color="primary" ref="editBtn">
          Edit
        </v-btn>
      </can>
    </td>
  </tr>
</template>

<script>
// Vue Component
export default {
  created() {
    if (this.requirement.value && this.requirement.value.length) {
      this.input.radius = this.radius
      this.input.address = this.address
    }
  },
  props: {
    requirement: { type: Object, required: true },
    first: { type: Boolean },
  },
  data: () => {
    return {
      input: {
        radius: 10,
        address: '',
      },
    }
  },
  computed: {
    radius() {
      if (typeof this.requirement.value !== 'string') return 0
      return this.requirement.value.match(/^\d+/)[0]
    },
    address() {
      if (typeof this.requirement.value !== 'string') return ''
      return this.requirement.value.match(/^\d+(km) from (.+)$/i)[2]
    },
  },
  methods: {
    cancel() {
      this.$store.dispatch('opportunities/fetch', this.$route.params.id)
      this.requirement.editing = false
    },
    destroy() {
      if (this.requirement.id) {
        this.$store.dispatch('requirements/destroy', this.requirement)
      }
      this.$store.dispatch('opportunities/fetch', this.$route.params.id)
    },
    submit() {
      const value = `${this.input.radius}km from ${this.input.address}`
      if (this.requirement.id) {
        this.$store
          .dispatch('requirements/update', { ...this.requirement, ...{ value } })
          .then(feedback => {
            if (feedback) {
              this.$store.commit('snackbar', {
                text: 'There was a problem updating the requirement',
                type: 'error',
              })
              this.requirement = feedback
            } else {
              this.$store.commit('snackbar', {
                text: 'Requirement was updated successfully',
                type: 'success',
              })
            }
          })
      } else {
        this.$store
          .dispatch('requirements/create', { ...this.requirement, ...{ value } })
          .then(feedback => {
            if (feedback) {
              this.$store.commit('snackbar', {
                text: 'There was a problem creating the requirement',
                type: 'error',
              })
              this.requirement = feedback
            } else {
              this.$store.commit('snackbar', {
                text: 'Requirement was created successfully',
                type: 'success',
              })
            }
          })
      }
    },
  },
}
</script>
